import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import "../../../styles/ResidentialListing.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import importantNotes from "../../../data/Quebec/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import ClauseCard from "../../ClauseCard.js";
import clauseCardDesc from "../../../data/Quebec/clauseCardDescription.js";
import clauseData from "../../../data/Quebec/clauseData.js";
import Checkbox from "@mui/material/Checkbox";

export default function LeaseListing() {
  const [ListingData, setListingData] = useState([
    "RECO Info Guide Acknowledgement",
    "Listing Agreement with Schedule A (272)",
    "MLS Data Form(s)",
    "Schedule B1 (upload to listing)",
    "Full REALTOR® MLS Printout",
  ]);

  const [ListingType, setListingType] = useState("MLS");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [Is244, setIs244] = useState("No");

  // State for conditional documents that can be added/removed
  const [conditionalDocuments, setConditionalDocuments] = useState({
    "Do you or close relatives own the property?": false,
    "Do you have a delayed offer presentation date or other directions?": false,
  });

  // Mapping of checkbox labels to their corresponding listing data strings
  const documentMapping = {
    "Do you or close relatives own the property?":
      "Registrant's Disclosure of Interest - Disposition (161)",
    "Do you have a delayed offer presentation date or other directions?":
      "Seller's Direction re: Property/Offers (244)",
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const setExclusive = (e) => {
    setListingType("Exclusive");
    let newListingData = ListingData;

    setListingData(
      newListingData.filter(
        (item) =>
          item !== "Full REALTOR® MLS Printout" && item !== "MLS Data Form(s)"
      )
    );
  };

  const setMLS = (e) => {
    setListingType("MLS");
    let newListingData = ListingData;
    if (newListingData.includes("MLS Data Form(s)") === true) {
      return;
    } else {
      newListingData.push("MLS Data Form(s)");
      newListingData.push("Full REALTOR® MLS Printout");
    }
    setListingData(newListingData);
  };

  // Function to handle conditional document checkboxes
  const toggleConditionalDocument = (documentName) => {
    setConditionalDocuments((prev) => {
      const newState = {
        ...prev,
        [documentName]: !prev[documentName],
      };

      // Get the corresponding string for the listing data
      const listingDataString = documentMapping[documentName];

      // Update Is244 state if this is the delayed offer presentation checkbox
      if (
        documentName ===
        "Do you have a delayed offer presentation date or other directions?"
      ) {
        setIs244(newState[documentName] ? "Yes" : "No");
      }
      if (documentName === "Do you or close relatives own the property?") {
        setIsDisclosure(newState[documentName] ? "Yes" : "No");
      }

      // Update the listing data based on checkbox state
      setListingData((prevListingData) => {
        let newListingData = [...prevListingData];

        if (newState[documentName]) {
          // Add document if checked and not already present
          if (!newListingData.includes(listingDataString)) {
            newListingData.push(listingDataString);
          }
        } else {
          // Remove document if unchecked
          newListingData = newListingData.filter(
            (item) => item !== listingDataString
          );
        }

        return newListingData;
      });

      return newState;
    });
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-4">
          <div className="pr-5 ">MLS or Exclusive Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
              >
                <FormControlLabel
                  value="MLS"
                  control={<Radio size="small" onClick={setMLS} />}
                  label="MLS"
                />
                <FormControlLabel
                  value="Exclusive"
                  control={<Radio size="small" onClick={setExclusive} />}
                  label="Exclusive"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>

        {/* Check all that apply section */}
        <div className="flex flex-col items-left pb-4">
          <div className="pr-5 pb-2 ">
            For each "Yes" response, check the box that applies:
          </div>
          <ThemeProvider theme={theme}>
            <div className="flex flex-col ">
              {Object.keys(conditionalDocuments).map((documentName) => (
                <FormControlLabel
                  key={documentName}
                  control={
                    <Checkbox
                      size="small"
                      checked={conditionalDocuments[documentName]}
                      onChange={() => toggleConditionalDocument(documentName)}
                    />
                  }
                  label={documentName}
                />
              ))}
            </div>
          </ThemeProvider>
        </div>
      </div>
      {IsDisclosure === "Yes" ? (
        <>
          <div className="flex w-full pl-4 pt-3 items-center ">
            <div className="pb-5 pr-3">
              <div className="float-left mr-3 pt-2">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  size="2xl"
                  color="#cc0000"
                />
              </div>
              <div>
                As per TRESA, you cannot represent both clients in a trade when
                you have interest in the listed property. As a result, if you
                bring a Tenant client to the trade, you must release or refer
                one of the client(s) to another agent. Additionally, you can
                collect a referral fee on the client referral.
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      <ChecklistCard
        province={"QC"}
        Title1={""}
        CheckListData={ListingData}
        Header={ListingType + " Listing:"}
        Header2={"Landlord Client"}
      />
      <ClauseCard
        ClauseCardDescription={clauseCardDesc.filter((item) =>
          item.category.includes("resListing")
        )}
        ClauseDataCommon={clauseData.filter(
          (item) =>
            item.category.includes("forlease") && item.isCommon === "yes"
        )}
        ClauseDataSituational={clauseData.filter(
          (item) => item.category.includes("forlease") && item.isCommon === "no"
        )}
      />
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        {Is244 === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("directions") === true
            )}
          />
        ) : (
          ""
        )}
        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true
            )}
          />
        ) : (
          ""
        )}

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("lease") === true
          )}
        />
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("listing") === true
          )}
        />
        {ListingType === "MLS" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("mls") === true
            )}
          />
        ) : (
          ""
        )}
      </div>
      <BackToTop />
    </div>
  );
}
